import { apiService } from "./../../app.service";

export const registerApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (data) => ({
        url: "/auth/register",
        method: "POST",
        body: data,
      }),
    }),

    sendEmailForVerify: builder.mutation({
      query: (data) => ({
        url: "/auth/sendEmailForVerify",
        method: "POST",
        body: data,
      }),
    }),

    createAccount: builder.mutation({
      query: (data) => ({
        url: "/auth/createAccount",
        method: "POST",
        body: data,
      }),
    }),

    createRestaurant: builder.mutation({
      query: (data) => ({
        url: "/auth/createRestaurant",
        method: "POST",
        body: data,
      }),
    }),

    completeWizard: builder.mutation({
      query: (data) => ({
        url: "/auth/complete-wizard",
        method: "POST",
        body: data,
      }),
    }),

    confirmSessionId: builder.mutation({
      query: (data) => ({
        url: "/auth/confirmSessionId",
        method: "POST",
        body: data,
      }),
    }),

    createSignupCheckout: builder.mutation({
      query: (data) => ({
        url: "/payment/create-signup-checkout",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useSendEmailForVerifyMutation,
  useCreateAccountMutation,
  useCreateRestaurantMutation,
  useConfirmSessionIdMutation,
  useCompleteWizardMutation,
  useCreateSignupCheckoutMutation,
} = registerApi;
